// ------------------- utilities ------------------- //

const isBoolean = (candidate: any): candidate is boolean =>
  candidate !== null && typeof candidate === 'boolean';
const isCapabilityObject = (
  candidate: any
): candidate is CMxCommonApp.CapabilityObject => {
  return (
    candidate !== null && typeof candidate === 'object' && `value` in candidate
  );
};

const capabilityValue = (
  capability: any,
  defaultVal: boolean = false
): boolean => {
  if (isBoolean(capability)) {
    return capability;
  }
  if (isCapabilityObject(capability)) {
    return capability.value;
  }
  return false;
};

const conditionalCapabilityValue = (
  capability?: CMxCommonApp.CapabilityValue,
  every?: CMxCommonApp.CapabilityValue[],
  some?: CMxCommonApp.CapabilityValue[]
): boolean => {
  const isEverySatisfied =
    every?.every(element => capabilityValue(element) === true) ?? true;
  const isSomeSatisfied =
    some?.some(element => capabilityValue(element) === true) ?? true;
  const capabilityObjValue = capabilityValue(capability);
  return isEverySatisfied && isSomeSatisfied && capabilityObjValue;
};

const getStrings = (
  capability: any,
  stringBundle: Record<string, string> = {},
  fallback: string = 'This feature is not available.'
) => {
  if (isCapabilityObject(capability)) {
    const strings = capability.reasons
      .map(reason => {
        return stringBundle[reason];
      })
      .filter(Boolean);

    if (strings?.length > 0) {
      return strings;
    }
  }

  return fallback;
};

const enabledCapability = {
  on: {
    value: true,
    reasons: []
  },
  actionable: {
    value: true,
    reasons: []
  }
};

const disabledCapability = {
  on: {
    value: false,
    reasons: []
  },
  actionable: {
    value: false,
    reasons: []
  }
};

export {
  isBoolean,
  getStrings,
  isCapabilityObject,
  capabilityValue,
  conditionalCapabilityValue,
  enabledCapability,
  disabledCapability
};
